import 'ui-core/basic/base/js/base';
(function (UX) {
    setTimeout(function () {
        if ($('.leader').children('script').length > 0 && window.innerWidth < UX.grid.screenMd) {
            $('.ad-banner').hide();
        }
    }, 2000);
})(UX);
